const TransactionState = {
  transactions: {data: []},
  paymentLogs: {data: []},
  getProviderLogs: {data: []},
  transactionQueryParams: {}
};

export default TransactionState;
